import {
	Box,
	Divider,
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useMemo } from 'react';
import strings from '../../Globalization';
import consts from '../../consts';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';
import { useSterilizerCycleInfo } from './Context';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));

const CriticalParameters = () => {
	const { data, isSteam, isLeakTestCycle, isAMSCOEU, isSteamEU } = useSterilizerCycleInfo();
	const parameters = useMemo(() => {

		const params = data.CriticalParameters;

		return Array.isArray(params) ? params.map((row, i) => (
			<StyledTableRow key={`row-${i}`}>
				{row.map(({ tabHeader = false, text = '', pressureUnit = '', unitSubHeader = '', unitHeader = '', labelFormatterValue = '', CriticalParameterIcon = null, indices, ...rest }, j) => (
					<TableCell align="left" {...rest} key={`row-${i}-cell-${j}`}>
						{tabHeader && <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}
						{
							`${strings.formatString(strings[text.trim()], labelFormatterValue) || text}
					 ${pressureUnit} ${unitHeader} ${unitSubHeader}`
						}
						{indices && indices}
						<ProcessMonitoringStatus CriticalParameterIcon={CriticalParameterIcon} align={'center'} width={100} />
					</TableCell>
				))}
			</StyledTableRow>
		)) : [];
	}, [data, isAMSCOEU, isLeakTestCycle, isSteam, isSteamEU]);


	return (
		<Grid container>
			<Grid size={12}>
				{data.CycleStatusId === consts.CycleStatus.Pass && parameters.length !== 0 && (
					<Box>
						{Object.keys(data).length > 0 ? (
							<TableContainer>
								<Table size="small" aria-label="Critical parameters table">
									<TableHead>
										<TableRow>
											<TableCell align="left">
												{strings.Parameter}
											</TableCell>
											{(isLeakTestCycle || !isSteamEU || isSteam || isAMSCOEU) && (
												<TableCell align="left"></TableCell>
											)}
											<TableCell align="left">
												{strings.Metric}
											</TableCell>
											{(!isSteamEU || isLeakTestCycle) && (
												<TableCell align="left">
													{strings.Actual}
												</TableCell>
											)}
											{!isLeakTestCycle && isSteamEU && (
												<TableCell align="left">
													{strings.Control}
												</TableCell>
											)}
											{isSteamEU && !isLeakTestCycle && !isAMSCOEU && (
												<TableCell align="left">
													{strings.Independent}
												</TableCell>
											)}
											<TableCell align="left">
												{strings.CriticalParamenterTitle}
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>{parameters}</TableBody>
								</Table>
							</TableContainer>
						) : null}
					</Box>
				)}
			</Grid>
			<Grid size={12}>
				<Divider />
			</Grid>
		</Grid>
	);
};

export default CriticalParameters;
